/* eslint-disable max-lines-per-function */
import React from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import type { ContractSuccessData } from "./step-7-success";

export const PropertyManagerSend: React.FC<{
  propertyName: string;
  supervisorEmail: string;
  onGoToSuccess?: (data: ContractSuccessData) => void;
  createEmailRequest: () => Promise<{ signatureRequestId?: string }>;
  cancelIfNeeded: () => Promise<void>;
}> = ({
  propertyName,
  supervisorEmail,
  onGoToSuccess,
  createEmailRequest,
  cancelIfNeeded,
}) => {
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleSendToSupervisor = async () => {
    setError(null);
    setBusy(true);
    try {
      await cancelIfNeeded();
      await createEmailRequest();
      onGoToSuccess?.({
        variant: "pm",
        signerEmail: supervisorEmail,
        propertyName,
      });
    } catch (e: unknown) {
      setError(
        e && typeof e === "object" && "message" in e ? String((e as { message: string }).message) : "Failed to send contract",
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Typography variant="h6">Send Contract</Typography>
      <Divider style={{ width: "100%", margin: "8px 0" }} />
      <Typography variant="body1" gutterBottom>
        Looks good? Send to {supervisorEmail}.
      </Typography>
      {error && (
        <Typography variant="body2" color="error" gutterBottom>
          {error}
        </Typography>
      )}
      <Grid size={{ xs: 12 }} style={{ marginTop: 16 }}>
        <Button
          style={{ marginLeft: 8 }}
          variant="contained"
          color="primary"
          onClick={handleSendToSupervisor}
          disabled={busy || !supervisorEmail}
        >
          Send Now
        </Button>
      </Grid>
    </>
  );
};

export default PropertyManagerSend;


